import { render } from "./ChangePassword.vue?vue&type=template&id=bd5c7c4c"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=bd5c7c4c&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__